import { OAS3ComponentWrapFactory } from "../helpers"
import OnlineValidatorBadge from "core/components/online-validator-badge"

// OAS3 spec is now supported by the online validator.
export default OAS3ComponentWrapFactory(OnlineValidatorBadge)
